import React, { useEffect, useRef } from "react";

import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

import { useLoader } from "../../../hooks";

import { LoaderComponent } from "../../decorate";

function CustomCropper({ logo_url, handleUrls }) {
  const imgRef = useRef(null);
  const { onLoader, offLoader } = useLoader();

  const handleCrop = () => {
    if (imgRef.current) {
      const cropper = imgRef.current.cropper;
      const url = cropper.getCroppedCanvas().toDataURL();
      handleUrls({
        cropped_url: url,
      });
    }
  };

  useEffect(() => {
    onLoader();
  }, []);

  return (
    <div className="selectionToolSec">
      <div className="cropSec" style={{ height: 400 }}>
        <div className="">
          <p className="p-0">Crop your image</p>
        </div>
        <div className="" style={{ position: "relative", height: "100%" }}>
          <LoaderComponent />
          <Cropper
            style={{ height: 300 }}
            cropmove={handleCrop}
            autoCropArea={1}
            src={logo_url}
            guides={true}
            ref={imgRef}
            onLoad={() => offLoader()}
            zoomable={false}
          />
        </div>
      </div>
    </div>
  );
}

export default CustomCropper;
